// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"e71e0b20","228":"937708e4","441":"243978eb","680":"68407ff8","722":"7a010176","789":"9675c22e","819":"752080b5","986":"dcad8f21"}[chunkId] + ".chunk.js";
};